module.exports = __webpack_public_path__ + "static/media/Second.127b1694.png";